import { render, staticRenderFns } from "./Withdraw.vue?vue&type=template&id=6130a21c&scoped=true&"
import script from "./Withdraw.vue?vue&type=script&lang=js&"
export * from "./Withdraw.vue?vue&type=script&lang=js&"
import style0 from "./Withdraw.vue?vue&type=style&index=0&id=6130a21c&prod&scoped=true&lang=css&"
import style1 from "./Withdraw.vue?vue&type=style&index=1&id=6130a21c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6130a21c",
  null
  
)

export default component.exports